// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3Jr7i","title":"InfoRow_title__1-Vvl"};